import { Component } from '@angular/core';
import { NavController, NavParams } from 'ionic-angular';

import { BaseListPage } from '../../providers/base-list-page';
import { BusinessMessageProvider } from '../../providers/business-message-handler';

@Component({
  selector: 'page-business-message-log-list',
  templateUrl: 'business-message-log-list.html',
})
export class BusinessMessageLogListPage extends BaseListPage {
	constructor(
		public navCtrl: NavController, 
		public navParams: NavParams, 
		public businessMessageProvider: BusinessMessageProvider
		) {
		super();

		this.isLoading = true;
		this.load(null);
	}

	doRefresh(refresher) {
		this.params.page = 1;
		
		this.load(()=>{
		  refresher.complete();
		})
	}  	

	doInfinite(infiniteScroll){
		if(!this.lastRequestReturnedValues){
			infiniteScroll.complete();
			return;
		} 

		this.params.page++;

		this.load(()=>{
			infiniteScroll.complete();
		});
	}

	load(cb){
		this.params.cbAfter = cb;
		
		this.businessMessageProvider.getMessages(this.params);
	}	
}



// WEBPACK FOOTER //
// ./src/pages/business-message-log-list/business-message-log-list.ts